import React, { useState } from 'react';

import { loadCoinBalance, saveCoinBalance } from '../engine/GameState';

const CONTINUE_COST = 50;

export default function GameOverScreen({
  score,
  coins,
  distance,
  highScore,
  isNewHighScore,
  onRestart,
  onContinue,
  onGoHome,
  onOpenShop,
  completedMissions,
}) {
  const [coinBalance, setCoinBalance] = useState(loadCoinBalance);
  const [continueUsed, setContinueUsed] = useState(false);
  const canContinue = coinBalance >= CONTINUE_COST && !continueUsed;

  const handleContinue = () => {
    if (!canContinue) return;
    const newBalance = coinBalance - CONTINUE_COST;
    setCoinBalance(newBalance);
    saveCoinBalance(newBalance);
    setContinueUsed(true);
    onContinue?.();
  };

  return (
    <div
      className="absolute inset-0 z-30 flex items-center justify-center"
      style={{ background: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(4px)' }}
    >
      <div
        className="p-6 rounded-2xl text-center max-w-sm w-full mx-4"
        style={{
          background: 'linear-gradient(135deg, #1a0a2e, #2d1a4e)',
          border: '2px solid rgba(99,102,241,0.5)',
          boxShadow: '0 0 40px rgba(99,102,241,0.3)',
        }}
      >
        {/* Title */}
        <div className="text-5xl mb-2">{isNewHighScore ? '🏆' : '💀'}</div>
        <h2 className="font-heading font-black text-2xl text-white mb-1">
          {isNewHighScore ? 'New High Score!' : 'Game Over'}
        </h2>

        {/* Score */}
        <div className="my-4 p-4 rounded-xl" style={{ background: 'rgba(255,255,255,0.05)' }}>
          <div className="grid grid-cols-3 gap-3">
            <div>
              <p className="font-data text-2xl font-black" style={{ color: '#6366f1' }}>{score?.toLocaleString()}</p>
              <p className="font-caption text-xs" style={{ color: 'rgba(255,255,255,0.5)' }}>Score</p>
            </div>
            <div>
              <p className="font-data text-2xl font-black" style={{ color: '#f59e0b' }}>{coins}</p>
              <p className="font-caption text-xs" style={{ color: 'rgba(255,255,255,0.5)' }}>Coins</p>
            </div>
            <div>
              <p className="font-data text-2xl font-black" style={{ color: '#10b981' }}>{distance}m</p>
              <p className="font-caption text-xs" style={{ color: 'rgba(255,255,255,0.5)' }}>Distance</p>
            </div>
          </div>
          {highScore > 0 && (
            <p className="font-caption text-xs mt-2" style={{ color: 'rgba(255,255,255,0.4)' }}>
              Best: <span style={{ color: '#f59e0b', fontFamily: 'var(--font-data)' }}>{highScore?.toLocaleString()}</span>
            </p>
          )}
        </div>

        {/* Completed missions */}
        {completedMissions?.length > 0 && (
          <div className="mb-4 p-3 rounded-xl" style={{ background: 'rgba(16,185,129,0.1)', border: '1px solid rgba(16,185,129,0.3)' }}>
            <p className="font-caption text-xs font-semibold mb-2" style={{ color: '#10b981' }}>MISSIONS COMPLETED!</p>
            {completedMissions?.map(m => (
              <div key={m?.id} className="flex items-center justify-between text-xs">
                <span className="text-white">{m?.name}</span>
                <span style={{ color: '#f59e0b' }}>+{m?.reward} 🪙</span>
              </div>
            ))}
          </div>
        )}

        {/* Continue option */}
        {!continueUsed && (
          <button
            onClick={handleContinue}
            disabled={!canContinue}
            className="w-full py-3 rounded-xl font-bold text-white mb-3 transition-all"
            style={{
              background: canContinue ? 'linear-gradient(135deg, #f59e0b, #d97706)' : 'rgba(255,255,255,0.1)',
              opacity: canContinue ? 1 : 0.5,
              cursor: canContinue ? 'pointer' : 'not-allowed',
            }}
          >
            {canContinue ? `🔄 Continue (${CONTINUE_COST} 🪙)` : `Not enough coins (need ${CONTINUE_COST} 🪙)`}
          </button>
        )}

        {/* Action buttons */}
        <div className="grid grid-cols-2 gap-2">
          <button
            onClick={onRestart}
            className="py-3 rounded-xl font-bold text-white transition-all hover:scale-105 active:scale-95"
            style={{ background: 'linear-gradient(135deg, #6366f1, #8b5cf6)' }}
          >
            🎮 Play Again
          </button>
          <button
            onClick={onGoHome}
            className="py-3 rounded-xl font-bold transition-all hover:scale-105 active:scale-95"
            style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', color: 'white' }}
          >
            🏠 Home
          </button>
        </div>

        <button
          onClick={onOpenShop}
          className="w-full mt-2 py-2 rounded-xl text-sm transition-all"
          style={{ color: 'rgba(255,255,255,0.5)', border: '1px solid rgba(255,255,255,0.1)' }}
        >
          🛒 Visit Shop
        </button>
      </div>
    </div>
  );
}
